module.exports = {
  messages: {
    CN: {
      step3TipTitle: "添加好友限制",
      step3TipCon:
        "  为了防止触发LinkedIn账号风控，请尽量控制每个账号每日添加好友的上限，",
      step3TipCon1:
        "普通账号每日最好不要超过20人，navigator账号每日最好不要超过35人。",
      step3TipTitle2: "账号工作时间",
      step3TipCon2:
        "每个LinkedIn账号会根据您绑定账号时选择的代理区域，按照当地的工作时间实行8小时工作制。账号会在工作时间内执行搜索，添加好友，与好友对话等事项，超出工作时间将暂停工作，直至第二天工作时间重新开启。",
      bindLinkAccTipBtnTxt: "to view the detailed documentation.",
      bindLinkAccTipBtn: "点击",
      dailyConnectionLimit: "每日连接请求限制",
      dailyLimitSubtitle:
        "设置每日发送连接请求的最大数量。频率过高可能触发LinkedIn风控，过低则效率不足。",
      safeTips: "安全提示",
      safeTipsContent:
        "领英对新账户有更严格的限制。建议新账户每天从 10–15 次请求开始，并在使用 1-2 个月后逐步增加这一数量。",
      selectAllocationMode: "选择分配模式",
      newAccountLimitTip:
        "领英对新账号的限制更为严格。建议新账号每天从 10–15 次请求开始，使用 1–2 个月后再逐步增加。",
      allocationModeTip:
        "您可以在一个 LinkedIn 账号下创建多个营销活动。可以选择按创建顺序运行（将每日请求优先分配给第一个营销活动，完成后再转向下一个），或均匀分配（将每日请求一次性分摊给所有运行中的营销活动）。您可以按需设置。",
    },
    US: {
      step3TipTitle: "Connection Request Limits",
      step3TipCon:
        "  To avoid triggering LinkedIn's security, please limit daily connection requests for each account.",
      step3TipCon1:
        "We recommend that users do not exceed 20 requests per day for regular accounts.We recommend that users do not exceed 35 requests per day for navigator accounts.",
      step3TipTitle2: "Account Operating Hours",
      step3TipCon2:
        "Each LinkedIn account runs on an 8-hour workday schedule. The selected proxy region determines the local time. The account will search, send connection requests, and chat during these hours. Operations will pause outside of working hours. They will resume the next business day when working hours begin again.",
      bindLinkAccTipBtn: "Click here ",
      bindLinkAccTipBtnTxt: "to view the detailed documentation.",
      dailyConnectionLimit: "Daily Connection Request Limit",
      dailyLimitSubtitle:
        "Set the maximum number of connection requests sent per day. A rate that is too high may trigger LinkedIn's risk control, while one that is too low will be inefficient.",
      safeTips: "Safe Tips",
      safeTipsContent:
        "LinkedIn has stricter restrictions on new accounts. It is recommended that new accounts start with 10–15 requests per day and gradually increase this number after 1-2 months of use.",
      selectAllocationMode: "Select Allocation Mode",
      newAccountLimitTip:
        "LinkedIn applies stricter limits to new accounts. We recommend new accounts start at 10–15 requests per day and gradually increase after 1–2 months of use.",
      allocationModeTip:
        "You can create multiple campaigns under one LinkedIn account. Choose to run in creation order (give all daily requests to the first campaign, then move to the next once it’s done) or distribute evenly (split the daily requests across all running campaigns at once). Set it however you like.",
    },
    AR: {
      step3TipTitle: "حدود طلبات الاتصال",
      step3TipCon:
        "لتجنب تفعيل أمان LinkedIn، يرجى تحديد عدد طلبات الاتصال اليومية لكل حساب.",
      step3TipCon1: `نوصي بعدم تجاوز 20 طلبًا يوميًا للحسابات العادية.
نوصي بعدم تجاوز 35 طلبًا يوميًا لحسابات النافيغيتور.`,
      step3TipTitle2: "ساعات عمل الحساب",
      step3TipCon2:
        "يعمل كل حساب LinkedIn وفق جدول عمل يومي مدته 8 ساعات. تحدد المنطقة الزمنية المختارة حسب إعدادات البروكسي التوقيت المحلي. سيقوم الحساب بالبحث وإرسال طلبات الاتصال والدردشة خلال هذه الساعات. ستتوقف العمليات خارج ساعات العمل، وستستأنف في يوم العمل التالي عندما تبدأ ساعات العمل مرة أخرى.",
      bindLinkAccTipBtn: "انقر",
      bindLinkAccTipBtnTxt: " هنا لعرض الوثائق التفصيلية.",
      dailyConnectionLimit: "حد طلبات الاتصال اليومية",
      dailyLimitSubtitle:
        "قم بتعيين الحد الأقصى لعدد طلبات الاتصال المرسلة يوميًا. المعدل المرتفع جدًا قد يؤدي إلى تفعيل نظام الحماية في LinkedIn، بينما المعدل المنخفض جدًا سيكون غير فعال.",
      safeTips: "نصائح السلامة",
      safeTipsContent: `لدى LinkedIn قيود أكثر صرامة على الحسابات الجديدة. يُوصى بأن تبدأ الحسابات الجديدة بـ 10–15 طلبًا يوميًا، ثم تزيد هذا العدد تدريجيًا بعد 1-2 شهر من الاستخدام.`,
      selectAllocationMode: "اختر وضع التخصيص",
      newAccountLimitTip:
        "يفرض LinkedIn قيودًا أكثر صرامة على الحسابات الجديدة. نوصي بأن تبدأ الحسابات الجديدة بـ 10–15 طلبًا يوميًا، ثم تزيد هذا العدد تدريجيًا بعد 1–2 شهر من الاستخدام.",
      allocationModeTip:
        "يمكنك إنشاء حملات متعددة تحت حساب LinkedIn واحد. اختر التشغيل حسب ترتيب الإنشاء (تخصيص جميع الطلبات اليومية للحملة الأولى، ثم الانتقال إلى التالية بعد انتهائها) أو التوزيع بالتساوي (تقسيم الطلبات اليومية على جميع الحملات الجارية في وقت واحد). يمكنك تعيين ذلك كما تفضل.",
    },
  },
};
